import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const qualificationService = {
  getList,
  storeOrUpdate,
  getCheckinFormUserQualification,
  destroy
};

function getList(userId, type){
  return (
    axios
      .get(
        `${apiEndpoint.qualifications}?user_id=${userId}&type=${type}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function getCheckinFormUserQualification(formId, userId, type){
  return (
    axios
      .get(
        `${apiEndpoint.qualifications}/get-checkin-form-user-qualification?form_id=${formId}&user_id=${userId}&type=${type}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 && res.data.code === '0000'){
          return res.data;
        }
      })
  );
}

function storeOrUpdate(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.qualifications(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.qualifications,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function destroy ( id )
{
  return (
    axios
      .delete(
        apiEndpointFunction.qualifications(id),
        {
          headers: authHeader()
        }
      ).then( res =>
      {
        if ( res && res.status===200 )
        {
          return res.data;
        }
      } )
  );
}
